import { render, staticRenderFns } from "./DefectCoveringImageStrip.vue?vue&type=template&id=63b53b9a&scoped=true"
import script from "./DefectCoveringImageStrip.vue?vue&type=script&lang=js"
export * from "./DefectCoveringImageStrip.vue?vue&type=script&lang=js"
import style0 from "./DefectCoveringImageStrip.vue?vue&type=style&index=0&id=63b53b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b53b9a",
  null
  
)

export default component.exports